import { useQuery } from "@tanstack/react-query";

export function useEntityReminders(entityType: string | null, entityId: string | null) {
  return useQuery({
    queryKey: ["entityReminders", entityType, entityId],
    queryFn: () => fetch(`/api/reminders/for-entity/${entityType}/${entityId}`, { credentials: "include" }).then(r => r.json()),
    enabled: !!entityType && !!entityId,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
